import { render } from "./EditMotivoRechazoView.vue?vue&type=template&id=f704ed08&scoped=true"
import script from "./EditMotivoRechazoView.vue?vue&type=script&lang=js"
export * from "./EditMotivoRechazoView.vue?vue&type=script&lang=js"

import "./EditMotivoRechazoView.vue?vue&type=style&index=0&id=f704ed08&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f704ed08"]])

export default __exports__